<template lang="pug">
	div
		v-row(no-gutters)
			v-col.font-weight-bold(cols="2" v-if="!skipName")
			v-col.font-weight-bold(align="center") {{$dayjs().month(11).format('MMMM')}}
			v-col.font-weight-bold(align="center") {{$dayjs().month(0).format('MMMM')}}
			v-col.font-weight-bold(align="center") {{$dayjs().month(1).format('MMMM')}}
			v-col.font-weight-bold(align="center") {{$dayjs().month(2).format('MMMM')}}
			v-col.font-weight-bold(align="center") {{$dayjs().month(3).format('MMMM')}}
		v-divider
		span(v-for="destination in destinations")
			v-row.guarantee-table(no-gutters)
				v-col.dotted.pt-1.pl-1(cols="2" v-if="!skipName")
					nuxt-link(:to="destination.to") {{destination.name}}
				v-col.dotted.py-3(v-for="(value, index) in destination.snowguarantee" :key="index" align="center" justify="center")
					v-sheet(:color="colors[value]" tile height="12")
			v-divider
</template>


<style lang="sass">
.guarantee-table
	background-color: #f2fbff!important
	.dotted
		border-right: 1px dotted #ddd
</style>


<script>
export default {
	props: {
		destinations: {
			type: Array,
			default: () => []
		},
		skipName: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		colors: { 1: '#e6b0ab', 2: '#eaaf52', 3: '#00b44c' }
	})
};
</script>
